import { ICheckServiceResponse } from '../../../repositories/billing-tariffs/v3/check-service';
import { defaultTo } from 'ramda';
import { mapAutoProlongInfo } from './mapAutoProlongInfo';
import { mapServicesUnavailableMessage } from './mapServicesUnavailableMessage';
import { mapTotalAmount } from './mapTotalAmount';
import { mapDetails } from './mapDetails';
import { ICheckoutInfo } from '../../../types/reducers/checkoutInfo';

export function mapCheckoutInfo(response: ICheckServiceResponse): ICheckoutInfo {
  const {
    isAvailable,
    actionDescription,
    autoProlongInfo,
    insufficientFunds,
    unavailableCheckServiceMessage,
    writeOff,
  } = response || {};

  return {
    isPurchaseAvailable: defaultTo(false, isAvailable),
    submitText: defaultTo('Разместить', actionDescription),
    isInsufficientFunds: defaultTo(false, insufficientFunds),
    autoProlongInfo: mapAutoProlongInfo(autoProlongInfo),
    servicesUnavailableMessage: mapServicesUnavailableMessage(unavailableCheckServiceMessage),
    totalAmount: mapTotalAmount(writeOff),
    details: mapDetails(writeOff),
    promotionCost: defaultTo(0, writeOff?.promotionCost),
  };
}
